import 'react-tabs/style/react-tabs.css'

import { Content } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { PageHeader } from '../../components/PageHeader/PageHeader'
import { withQueryErrorBoundary } from '../../components/QueryErrorBoundary/withQueryErrorBoundary'

export const EditDatasetsRoot = withQueryErrorBoundary(() => {
  const { t } = useTranslation()
  const { datasetId } = useParams<{ datasetId: string }>()

  return (
    <Content>
      <PageHeader title={`${t('Dataset edit')} #${datasetId}`} />
    </Content>
  )
})
